// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2LEpV","colCheckbox":"styles_colCheckbox__1NILq"};